// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lang-pairs[data-v-ec725610] {\n  display: block;\n  width: 100%;\n  margin-bottom: 15px;\n}\n.lang-pairs__radio-label[data-v-ec725610] {\n  display: block;\n  width: 100%;\n}\n.lang-pairs__radio-label[data-v-ec725610]:not(:last-child) {\n  display: block;\n  margin-bottom: 12px;\n}\n@media (max-width: 768px) {\n.lang-pairs__radio-label[data-v-ec725610]:not(:last-child) {\n    margin-bottom: 15px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
